import state from './moduleDocumentLedgerState.js'
import mutations from './moduleDocumentLedgerMutations.js'
import actions from './moduleDocumentLedgerActions.js'
import getters from './moduleDocumentLedgerGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

